import React, { useEffect } from 'react';
import './OptionNoteModal.css';

const OptionNoteModal = ({ open, title, note, onClose }) => {
  // Close on Escape key (hook must not be conditional)
  useEffect(() => {
    if (!open) return undefined;
    const handler = (e) => {
      if (e.key === 'Escape') {
        onClose && onClose();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="note-modal-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-label={title || 'Note'}>
      <div className="note-modal" onClick={(e) => e.stopPropagation()}>
        <button className="note-modal-close" aria-label="Close" onClick={onClose}>
          ×
        </button>
        {title ? <h2 className="note-modal-title">{title}</h2> : null}
        <div className="note-modal-body">
          {typeof note === 'string' ? (
            <p>{note}</p>
          ) : (
            <pre>{JSON.stringify(note, null, 2)}</pre>
          )}
        </div>
      </div>
    </div>
  );
};

export default OptionNoteModal;
